<nav id="sidenav" 
(mouseenter)="onMouseEnter()"
(mouseleave)="onMouseLeave()"
> 
  <div>
    <div class="logo-container">
      <a (click)="handleNavigation('/')">
        <img 
        [src]="imageSrc" 
        alt="Logo"
        class="logo"
        >
      </a>
    </div>
    <ul>
      @for(item of navItems; track item) {
           <a
              (click)="handleItemClick(item)"
              class="sidenav-item"
              [routerLink]="item.action ? null : item.route"
              routerLinkActive="selected"
              [ngClass]="item.class"
            >
            <lib-icon [icon]="item.icon" class="icon"></lib-icon>
            <span>{{ item.name }}</span>
        </a>        
      }
    </ul>
  </div>
  <div>
    <ul>
      <div class="sidenav-item">
        <div class="current-profile">
          <a (click)="handleNavigation('/profile')" class="flex" [routerLinkActive]="'selected'">
            <span class="initials">{{ usersInitials() }}</span>
            <span class="text">{{ currentUser() }} </span> 
          </a>
        </div>
      </div>

      <div class="sidenav-item">
        <a (click)="this.authStore.logout();" (keydown.enter)="this.authStore.logout()" tabindex="0" [routerLinkActive]="'selected'" class="flex">
          <lib-icon [icon]="logoutIcon" class="icon"></lib-icon>
          <span class="text">Log out</span>
        </a>
      </div>
    </ul>
  </div>
</nav>